export default __webpack_public_path__ + "static/media/brigitte-intro.c0395844.mp3";